
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { avatars, avatars_active_status, avatars_full } from '../../index.const';


export default class LoginController {
    constructor($rootScope, $log, $state, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;
        this.Dialog = Dialog;

        this.avatars = avatars;
        this.avatars_full = avatars_full;
        this.avatars_active_status = avatars_active_status;
        
        this.user = {
            name: null,
            avatar: 0
        }

        this.state = {
            step: 1
        }

        this.credits = 0;
    }

    $onInit(){
        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.$state.go("main");
        }
    }

    compileAvatar(index, avatar){
        return this.user.avatar === index ? this.$rootScope.$avatars.actived[this.user.avatar] : avatar
    }

    submit(form){
        if(form.$invalid){
            return false;
        }
        
        if(this.user.avatar < 3)
            this.Dialog.showConfirmAvatar(this.user.avatar, 'Você escolheu a sua GUIA DE VIAGEM. <br> Deseja confirmar a sua escolha?' ,this.showConfirmAvatarSuccess.bind(this));    
        else
            this.Dialog.showConfirmAvatar(this.user.avatar, 'Você escolheu o seu GUIA DE VIAGEM. <br> Deseja confirmar a sua escolha?' ,this.showConfirmAvatarSuccess.bind(this));
    }
    
    showConfirmAvatarSuccess(){
        this.Session.create(this.user);
        this.$state.go('main');
    }    
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js